module.exports = __webpack_public_path__ + "7e07633c3f192e7f7d2cfcad295b2370.svg";